import script from "./detailMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./detailMeeting.vue?vue&type=script&setup=true&lang=js"

import "./detailMeeting.vue?vue&type=style&index=0&id=c09ebe84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c09ebe84"]])

export default __exports__